export default __webpack_public_path__ + "static/media/icon3dtabla.39e437c9.png";